module.exports = __webpack_public_path__ + "static/img/img-4.d294a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/img-4.png
// module id = foMF
// module chunks = 63